/**
 * Движение товара через ворота: приёмка сырья, отгрузка продукции, возвраты.
 *
 * Всё это документы, а не отметки о работе. Палеты в сменном отчёте бригады —
 * мера труда и склад не трогают; списывает и приходует только то, что здесь.
 * Иначе одна и та же продукция ушла бы дважды.
 *
 * Количества целые: сырьё в граммах, плитка в штуках.
 */
import { z } from 'zod';
import { RECEIPT_PHOTO_KINDS } from './enums.js';
const dateTimeField = z.string().datetime({ offset: true });
const documentField = z.string().trim().min(1, 'Укажите номер документа').max(120);
const partyField = z.string().trim().min(2, 'Укажите название').max(200);
const noteField = z.string().trim().max(1000).nullish();
export const receiptLineSchema = z
    .object({
    materialTypeId: z.string().uuid(),
    /** Сколько написано в накладной поставщика, граммы. */
    qtyByWaybillG: z.number().int().min(0).max(1_000_000_000_000),
    /** Сколько получилось по факту взвешивания, граммы. Приходуется именно это. */
    qtyActualG: z.number().int().min(0).max(1_000_000_000_000),
})
    .refine((line) => line.qtyByWaybillG > 0 || line.qtyActualG > 0, {
    message: 'Строка с двумя нулями смысла не имеет',
});
export const materialReceiptSchema = z.object({
    receiptId: z.string().uuid(),
    at: dateTimeField,
    supplier: partyField,
    waybillNumber: documentField,
    note: noteField,
    lines: z.array(receiptLineSchema).min(1, 'Добавьте хотя бы одну строку'),
    /**
     * Снимки груза и накладной. Приёмка — то место, где потом спорят о весе,
     * и фотография закрывает спор быстрее любых объяснений.
     */
    photos: z
        .array(z.object({ id: z.string().uuid(), kind: z.enum(RECEIPT_PHOTO_KINDS) }))
        .default([]),
});
/** Отгрузка и возврат — один документ с разным знаком. */
export const SHIPMENT_KINDS = ['SHIPMENT', 'RETURN'];
export const SHIPMENT_KIND_NAMES = {
    SHIPMENT: 'Отгрузка',
    RETURN: 'Возврат от покупателя',
};
export const shipmentLineSchema = z.object({
    productSizeId: z.string().uuid(),
    qtyPieces: z.number().int().min(1).max(1_000_000),
});
export const shipmentSchema = z.object({
    shipmentId: z.string().uuid(),
    kind: z.enum(SHIPMENT_KINDS),
    at: dateTimeField,
    customer: partyField,
    documentNumber: documentField,
    note: noteField,
    lines: z.array(shipmentLineSchema).min(1, 'Добавьте хотя бы одну строку'),
});
//# sourceMappingURL=warehouse.js.map